import { serializeFilters } from './serializer';

export function serializeContainersToRetrieveOrders(containerNumbers: string[]): string | void {
  const values = containerNumbers.map((cn) => ({ value: cn, label: cn }));
  const filterObj = { containerNumber: values, 'containerNumber.raw': [] };
  const serialized = btoa(JSON.stringify(serializeFilters(filterObj)));
  return serialized;
}
